var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.7143H21.4286V16.0088C21.4285 15.8375 21.377 15.6702 21.2809 15.5285C21.1849 15.3867 21.0485 15.2769 20.8894 15.2134L17.682 13.9277C17.5232 13.8642 17.387 13.7548 17.291 13.6133C17.1949 13.4719 17.1433 13.305 17.1429 13.134L17.1429 12.3814C17.6627 12.0831 18.0948 11.6531 18.3958 11.1347C18.6967 10.6164 18.8558 10.0279 18.8571 9.42854V7.71425C18.8573 7.11235 18.699 6.52101 18.3981 5.9997C18.0972 5.47838 17.6644 5.04546 17.1432 4.74445C16.622 4.44343 16.0307 4.28495 15.4288 4.28491C14.8269 4.28488 14.2356 4.4433 13.7143 4.74425",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0323 16.0705L10.8249 14.7848C10.6661 14.7214 10.5299 14.6119 10.4338 14.4705C10.3377 14.329 10.2862 14.1621 10.2857 13.9911V13.2385C10.8056 12.9402 11.2377 12.5102 11.5386 11.9919C11.8396 11.4735 11.9987 10.8851 12 10.2857L12 8.57139C12 7.66208 11.6388 6.79001 10.9958 6.14703C10.3528 5.50405 9.48074 5.14282 8.57143 5.14282C7.66211 5.14282 6.79004 5.50405 6.14706 6.14703C5.50408 6.79001 5.14285 7.66208 5.14285 8.57139L5.14285 10.2857C5.14416 10.8851 5.30329 11.4735 5.60422 11.9919C5.90515 12.5102 6.33728 12.9402 6.85714 13.2385V13.9911C6.85703 14.1624 6.80561 14.3297 6.70952 14.4715C6.61342 14.6133 6.47705 14.723 6.318 14.7865L3.11057 16.0723C2.95179 16.1357 2.81561 16.2452 2.71953 16.3866C2.62345 16.528 2.57188 16.695 2.57143 16.866L2.57143 19.7143L14.5714 19.7143V16.866C14.5713 16.6947 14.5199 16.5274 14.4238 16.3856C14.3277 16.2438 14.1913 16.1341 14.0323 16.0705Z",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1d0b35e346e8a0029fc1ee0a9665edbf.svg";
export { ForwardRef as ReactComponent };